import React, { useEffect, useState } from "react";

import Ticket from "../../components/Ticket";
import { i18n } from "../../translate/i18n";

import "./chat-tailwick.css";

/**
 * Layout Tailwick /chat: app-admin-page + card > (filtros+lista | conversa).
 */
export default function TicketsTailwickShell({ ticketId, listPanel, welcomePanel }) {
	const [mobileListOpen, setMobileListOpen] = useState(!ticketId);

	useEffect(() => {
		if (ticketId) {
			setMobileListOpen(false);
		}
	}, [ticketId]);

	const showListOnMobile = mobileListOpen || !ticketId;

	return (
		<div className="app-admin-page" style={{padding:"0"}}>
			<div className="card tailwick-chat-surface flex min-h-0 flex-1 flex-col overflow-hidden">
				<div className="flex h-full min-h-0 w-full flex-1">
					<div
						className={`h-full shrink-0 border-default-200 lg:border-e ${
							showListOnMobile ? "flex w-full md:w-auto" : "hidden md:flex"
						}`}
					>
						<div className="card relative flex h-full max-h-full flex-row overflow-hidden rounded-none shadow-none" style={{ width: 400 }}>
							{listPanel}
						</div>
					</div>

					<div
						className={`tailwick-user-chats flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-default-200 lg:border-e ${
							showListOnMobile && ticketId ? "hidden md:flex" : "flex w-full"
						}`}
					>
						{ticketId ? (
							<>
								{/* <div className="tailwick-chat-mobile-back flex items-center border-b border-default-200 px-2 py-1 lg:hidden">
									<button
										type="button"
										className="btn size-8 shrink-0 text-default-600"
										onClick={() => setMobileListOpen(true)}
										aria-label="Voltar para lista"
									>
										<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
											<path d="m15 18-6-6 6-6" />
										</svg>
									</button>
									<span className="text-sm font-medium text-default-700">
										{i18n.t("chat.layout.backToList")}
									</span>
								</div> */}
								<div className="tailwick-chat-root min-h-0 flex-1">
									<Ticket tailwickLayout onMobileBackToList={() => setMobileListOpen(true)} />
								</div>
							</>
						) : (
							<div className="flex h-full min-h-0 w-full flex-1 flex-col bg-default-50">
								{welcomePanel}
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

